import { useTranslation } from 'react-i18next';

import { Divider, Tooltip } from '@arco-design/web-react';

import { usePlatformConfig } from '@/hooks';

export default function LoginExtra({ setActiveTab }: { setActiveTab: (tab: string) => void }) {
  const { t } = useTranslation();
  const { platformConfig } = usePlatformConfig();
  return (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          opacity: 0.5,
        }}
      >
        <Divider />
        <span style={{ width: 'max-content', whiteSpace: 'nowrap' }}>{t('login-page:other.login.methods')}</span>
        <Divider />
      </div>
      <div style={{ display: 'flex', gap: '6px', justifyContent: 'center' }}>
        <Tooltip content={t('login-page:ldap.login')} position="bottom" mini>
          <img
            src={platformConfig.faviconURL}
            alt="ldap"
            style={{ width: 28, height: 28, cursor: 'pointer' }}
            onClick={() => setActiveTab('ldap')}
            onError={(event) => {
              event.currentTarget.src = '/images/favicon.svg';
            }}
          />
        </Tooltip>
      </div>
    </div>
  );
}
